export const REVIEW_FORECAST_WINDOW_DAYS = 90;

export const REVIEW_FORECAST_MAX_TIMEZONE_OFFSET_MINUTES = 14 * 60;
